import themes from "daisyui/src/theming/themes";

export const USE_FREE_API = false; // 控制是否使用免费API的开关

const config = {
  // REQUIRED
  appName: "wan22.io",
  // REQUIRED: a short description of your app for SEO tags (can be overwritten)
  appDescription: "Create high-quality audio and video content easily with the open-source Wan 2.2 video generation model.",
  // REQUIRED (no https://, not trialing slash at the end, just the naked domain)
  domainName: "wan22.io",
  statDomainName: "wan22.io",
  ctaLink: "/wan22",
  // 添加 links 配置
  links: {
    email: "support@wan22.io"
  },
  crisp: {
    // Crisp website ID. IF YOU DON'T USE CRISP: just remove this => Then add a support email in this config file (mailgun.supportEmail) otherwise customer support won't work.
    id: "",
    // Hide Crisp by default, except on route "/". Crisp is toggled with <ButtonSupport/>. If you want to show Crisp on every routes, just remove this below
    onlyShowOnRoutes: ["/"],
  },
  stripe: {
    popularIndex: 1,
    plans: [
      // {
      //   name: "Onetime",
      //   prices: {
      //     stripe: {
      //       oneTime: {
      //         development: "price_dev_onetime",
      //         production: "price_1PtUl3DTVbs8Ct2AAo59IuNl"
      //       }
      //     },
      //     paypro: {
      //       oneTime: {
      //         development: "111085",
      //         production: "110991"
      //       }
      //     },
      //     creem: {
      //       oneTime: {
      //         development: "prod_3ddXM4IhCjcVkmYbVvGdh9",
      //         production: "prod_3ddXM4IhCjcVkmYbVvGdh9"
      //       }
      //     },
      //     antom: {
      //       oneTime: {
      //         development: "ANTOM_ONETIME",
      //         production: "ANTOM_ONETIME_PROD"
      //       }
      //     }
      //   },
      //   price: 9.9,
      //   credits: 30,
      //   isOneTime: true,
      // },
      {
        name: "Basic",
        prices: {
          stripe: {
            monthly: {
              development: "price_1RdRc9HUTJPB2z31RyVAEbnK",
              production: "price_1Rq6ryHUTJPB2z317DVrNIW7"
            },
            yearly: {
              development: "price_1RdVNKHUTJPB2z31gz79hji8",
              production: "price_1Rq6uTHUTJPB2z31BJSaERUK"
            }
          },
          paypro: {
            monthly: {
              development: "109724",
              production: "109988"
            },
            yearly: {
              development: "109724",
              production: "110014"
            }
          },
          creem: {
            monthly: {
              development: "prod_7Ey1hB7gFCwvM9teduBpjG",
              production: "prod_4BSxkmx4PAoMqnpphpEBvS"
            },
            yearly: {
              development: "prod_2HIJgvjS9AJPACw2dXEGSF",
              production: "prod_5M1ESt9p46gs3mgorMBqsG"
            }
          },
          antom: {
            monthly: {
              development: "ANTOM_BASIC_MONTHLY",
              production: "ANTOM_BASIC_MONTHLY_PROD"
            },
            yearly: {
              development: "ANTOM_BASIC_YEARLY",
              production: "ANTOM_BASIC_YEARLY_PROD"
            }
          }
        },
        price: 29.9,
        yearlyPrice: 20.9,
        credits: 630,
        yearlyCredits: 9800,
      },
      {
        name: "Plus",
        prices: {
          stripe: {
            monthly: {
              development: "price_1Pg5j3DTVbs8Ct2AtEkouT0Q",
              production: "price_1Rq6u4HUTJPB2z315bhKvohY"
            },
            yearly: {
              development: "prod_20BfGBCFLZ1E9gmQ37uYaz",
              production: "price_1Rq6ugHUTJPB2z31mfcPXdDt"
            }
          },
          paypro: {
            monthly: {
              development: "109724",
              production: "110013"
            },
            yearly: {
              development: "109724",
              production: "110015"
            }
          },
          creem: {
            monthly: {
              development: "prod_3fXDu0U1QHHLidLKSWKMHh",
              production: "prod_4PbnvKW6U7pMuDhKUDU5bE"
            },
            yearly: {
              development: "prod_20BfGBCFLZ1E9gmQ37uYaz",
              production: "prod_6ajR8NXvQZoUhEYpzyNAGp"
            }
          },
          antom: {
            monthly: {
              development: "ANTOM_PRO_MONTHLY",
              production: "ANTOM_PRO_MONTHLY_PROD"
            },
            yearly: {
              development: "ANTOM_PRO_YEARLY",
              production: "ANTOM_PRO_YEARLY_PROD"
            }
          }
        },
        price: 49.9,
        yearlyPrice: 34.9,
        isFeatured: true,
        credits: 1600,
        yearlyCredits: 25200,
      },
      {
        name: "Pro",
        prices: {
          stripe: {
            monthly: {
              development: "price_1Pg5j3DTVbs8Ct2AtEkouT0Q",
              production: "price_1Rq6uCHUTJPB2z31b3fYRp6i"
            },
            yearly: {
              development: "price_1Pg5jvDTVbs8Ct2AoPCABJKs",
              production: "price_1Rq6urHUTJPB2z31mCEbT5Le"
            }
          },
          paypro: {
            monthly: {
              development: "109724",
              production: "110016"
            },
            yearly: {
              development: "109724",
              production: "110017"
            }
          },
          creem: {
            monthly: {
              development: "prod_2YG5oQrywmGFraG8JpXnxV",
              production: "prod_6OXEYGCADwi589osHq6FiZ"
            },
            yearly: {
              development: "prod_75qD6Lp2aHeWUTAugO83LW",
              production: "prod_2fKEawljqUzgQTJSyVOEJS"
            }
          },
          antom: {
            monthly: {
              development: "ANTOM_ENTERPRISE_MONTHLY",
              production: "ANTOM_ENTERPRISE_MONTHLY_PROD"
            },
            yearly: {
              development: "ANTOM_ENTERPRISE_YEARLY",
              production: "ANTOM_ENTERPRISE_YEARLY_PROD"
            }
          }
        },
        price: 99.9,
        yearlyPrice: 69.9,
        credits: 3600,
        yearlyCredits: 59400,
      },
    ],
  },
  // 添加积分包配置
  creditPacks: {
    popularIndex: 2, // 7.2k credits package ($179) is most popular
    packs: [
      {
        name: "Starter Pack",
        credits: 1100,
        price: 49.90,
        paymentType: "credit_pack_1100",
        priceId: {
          stripe: {
            development: "price_1RdRcbHUTJPB2z31UpOawrsM",
            production: "price_1Rq6v7HUTJPB2z3144OPmq7q"
          },
          creem: {
            development: "prod_LLpxRDyiKEYaOQklTSPDA",
            production: "prod_1510C3Czv8o7I4ya1xJz4D"
          }
        },
        description: "Perfect for getting started"
      },
      {
        name: "Basic Pack", 
        credits: 3500,
        price: 99.90,
        paymentType: "credit_pack_3500",
        priceId: {
          stripe: {
            development: "price_1RdRcbHUTJPB2z31UpOawrsM",
            production: "price_1Rq6vFHUTJPB2z31g6AL4MOj"
          },
          creem: {
            development: "prod_3k_credits_dev",
            production: "prod_7NzGvjW7g7gEyI3LhWMYFg"  
          }
        },
        description: "Great for regular use"
      },
      {
        name: "Value Pack",
        credits: 7200,
        price: 179.90,
        paymentType: "credit_pack_7200",
        priceId: {
          stripe: {
            development: "price_1RdRcbHUTJPB2z31UpOawrsM",
            production: "price_1Rq6vPHUTJPB2z31A6PE3gdN"
          },
          creem: {
            development: "prod_6k_credits_dev",
            production: "prod_1thX7yhHJvAzlKzgYmniFL"
          }
        },
        description: "Great value for money"
      },
      {
        name: "Popular Pack",
        credits: 11500,
        price: 279.90,
        paymentType: "credit_pack_11500",
        priceId: {
          stripe: {
            development: "price_1Rq6vYHUTJPB2z313QZgBvzt",
            production: "price_1Rq6vYHUTJPB2z313QZgBvzt"
          },
          creem: {
            development: "prod_10k_credits_dev",
            production: "prod_5jWRIUztbi4NcwqzL9vhfW"
          }
        },
        description: "Most popular choice",
        isPopular: true
      },
      {
        name: "Pro Pack",
        credits: 26000,
        price: 499.90,
        paymentType: "credit_pack_26000",
        priceId: {
          stripe: {
            development: "price_1RdRcbHUTJPB2z31UpOawrsM",
            production: "price_1Rq6vjHUTJPB2z31okyMMEga"
          },
          creem: {
            development: "prod_20k_credits_dev",
            production: "prod_4njWmaPMIFtIZq8wkUcBeN"
          }
        },
        description: "For content creators"
      },
      {
        name: "Business Pack",
        credits: 58000,
        price: 899.90,
        paymentType: "credit_pack_58000",
        priceId: {
          stripe: {
            development: "price_1RdRcbHUTJPB2z31UpOawrsM",
            production: "price_1Rq6vuHUTJPB2z31FtFntcpS"
          },
          creem: {
            development: "prod_40k_credits_dev",
            production: "prod_4vxmVyUqiNS2eY618OZ8eJ"
          }
        },
        description: "Perfect for businesses"
      }
    ]
  },
  aws: {
    // If you use AWS S3/Cloudfront, put values in here
    bucket: "bucket-name",
    bucketUrl: `https://bucket-name.s3.amazonaws.com/`,
    cdn: "https://cdn-id.cloudfront.net/",
  },
  // https://billnalen.beehiiv.com/p/replacing-mailgun-with-resend
  mailgun: {
    // subdomain to use when sending emails, if you don't have a subdomain, just remove it. Highly recommended to have one (i.e. mg.yourdomain.com or mail.yourdomain.com)
    subdomain: "",
    // REQUIRED — Email 'From' field to be used when sending magic login links
    fromNoReply: `Test <noreply@gmail.com>`,
    // REQUIRED — Email 'From' field to be used when sending other emails, like abandoned carts, updates etc..
    fromAdmin: `Marc at ShipFast <marc@mg.shipfa.st>`,
    // Email shown to customer if need support. Leave empty if not needed => if empty, set up Crisp above, otherwise you won't be able to offer customer support."
    supportEmail: "support@wan22.io",
    // When someone replies to supportEmail sent by the app, forward it to the email below (otherwise it's lost). If you set supportEmail to empty, this will be ignored.
    forwardRepliesTo: "zejia98@gmail.com",
  },
  colors: {
    main: "#8735D9",
    theme: "dark",
    gradient: {
      primary: "linear-gradient(90deg, #8735D9 0%, #44ff9a 100%)",
      secondary: "linear-gradient(90deg, #44ff9a -0.55%, #44b0ff 22.86%, #8b44ff 48.36%, #ff6644 73.33%, #ebff70 99.34%)"
    }
  },
  auth: {
    // REQUIRED — the path to log in users. It's use to protect private routes (like /dashboard). It's used in apiClient (/libs/api.js) upon 401 errors from our API
    loginUrl: "/signin",
    // REQUIRED — the path you want to redirect users after successfull login (i.e. /dashboard, /private). This is normally a private page for users to manage their accounts. It's used in apiClient (/libs/api.js) upon 401 errors from our API & in ButtonSignin.js
    callbackUrl: "/wan22",
  },
  payments: {
    // Reference: HideGen payment.providers (enabled / recommended / priority).
    enableProviderSelection: true,
    defaultProvider: "stripe",
    providers: {
      stripe: { enabled: false, recommended: true, priority: 1 },
      anyway: { enabled: true, recommended: false, priority: 2 },
      creem: { enabled: false, recommended: false, priority: 3 },
      paypro: { enabled: false, recommended: false, priority: 4 },
      antom: { enabled: false, recommended: false, priority: 5 },
    },
    // 支付方式显示配置
    methods: {
      anyway: {
        name: "Anyway",
        icon: "/icons/anyway.svg",
        description: "Secure checkout with Anyway",
      },
      stripe: {
        name: "Credit Card",
        icon: "/icons/stripe.svg",
        description: "Pay with credit card via Stripe"
      },
      paypro: {
        name: "PayPro",
        icon: "/icons/paypro.svg",
        description: "Fast and secure payment with PayPro",
        config: {
          pageTemplate: "19868",
          testMode: {
            secretKey: "tTn2sE9vG-"
          }
        }
      },
      creem: {
        name: "Creem",
        icon: "/icons/creem.svg",
        description: "Simple and straightforward payments with Creem",
        config: {
          // Creem相关配置
          testMode: process.env.NODE_ENV !== "production"
        }
      },
      antom: {
        name: "Antom Pay",
        icon: "/icons/antom.svg",
        description: "Digital currency payment with Antom"
      }
    }
  },
};

export default config;